<template>
  <div>
    <div class="footer flex align-center text-center bg-gray">
      <div style="width:100vw">
        <div>{{ footerInfo.customPhone }}<span v-if="footerInfo.adLine"
                                               style="padding-left: 20px">{{ footerInfo.adLine }}</span><span
          v-if="footerInfo.bookLine" style="padding-left: 20px">{{ footerInfo.bookLine }}</span><span
          v-if="footerInfo.afterSalePhone" style="padding-left: 20px">{{ footerInfo.afterSalePhone }}</span></div>
        <div class="padding-top-sm">{{ copyright }}<span v-if="icp" style="padding-left: 20px"></span>{{ icp }}</div>
      </div>
    </div>
    <div :style="{backgroundImage:'url(' + IMG_BASE_URL + '/index_bg.jpg)'}" style="height:124px;background-size: cover;background-position: center;background-repeat: no-repeat;"
         class="flex justify-between padding-right padding-left-xl align-center">
      <div>
        <img :src="IMG_BASE_URL + '/logo.png'"
             :height="appCode === 'bmkx' || appCode === 'gzrb' || appCode === 'haiguan' || appCode === 'grrb' || appCode === 'zgjg' || appCode === 'gzjyb' || appCode === 'gzfzb' || appCode === 'wanqing' || appCode === 'zgcz' || appCode === 'rmjc' || appCode === 'xxsb'? 80 : 124"/>
      </div>
      <div class="text-df text-right padding-top-lg" style="padding-right:280px">
        <img :src="IMG_BASE_URL + '/zxzdxt_right.png'" width="532" height="60"/>
        <div style="position: relative;right:0;bottom:0;padding-top:5px;padding-right:20px;"
             :style="{color: appCode === 'haiguan'?'white':'black'}">欢迎 {{ user.phone }} ｜ <span
          @click="nav2login" style="cursor: pointer">退出</span></div>
      </div>
    </div>
    <div class="padding-10p bg-red flex justify-start align-center text-bold"
         style="height: 40px;line-height: 38px">
      <router-link :to="item.path" class="padding-lr text-xl"
                   :class="currPath.indexOf(item.prefix) > 0?'menu-clicked':''"
                   v-for="(item, index) in menus" :key="index">
        <i :class="'cuIcon-' + item.icon"></i><span
        class="padding-left-xs text-lg">{{ item.label }}</span>
      </router-link>
<!--      <div class="padding-lr" style="cursor:pointer" @click="openInfo">-->
<!--        <i :class="'cuIcon-read'"></i><span-->
<!--        class="padding-left-xs text-lg">订阅指南</span>-->
<!--      </div>-->
    </div>
    <div class="padding-10p bg-gray padding-bottom-xl" style="padding-bottom:80px">
      <router-view @phoneChanged="updateUserPhone" :style="{'backgroundImage':'url(' + bgImg + ')'}"/>
    </div>
    <el-dialog
      title="选择一个行政区划"
      :show-close="false"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="450px">
      <v-region v-model="selected"></v-region>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changeArea">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               title="温馨提示"
               :visible.sync="popInfoVisible"
               width="30%">
      <span v-html="popUpStr"></span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="popInfoVisible =  false">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import bs from '@/services/data/bs'
import api from '@/services/data/api'
import config from '../../public/config/config'
import Cookies from 'js-cookie'

export default {
  name: 'index',
  data () {
    return {
      footerInfo: config.footer,
      copyright: config.copyright,
      icp: config.icp,
      bgImg: config.IMG_BASE_URL + '/login_BodyBg.jpg',
      appCode: config.APP_CODE,
      IMG_BASE_URL: config.IMG_BASE_URL,
      selected: {
        province: '',
        city: '',
        area: ''
      },
      dialogVisible: false,
      popInfoVisible: false,
      popUpStr: '',
      currPath: '',
      menus: [{
        label: '报刊征订',
        icon: 'home',
        path: '/pages/subscribe/mode',
        prefix: 'subscribe'
      }, {
        label: '订单查询',
        icon: 'form',
        path: '/pages/order-list',
        prefix: 'order'
      }, {
        label: '用户中心',
        icon: 'people',
        path: '/pages/personal',
        prefix: 'personal'
      }]
    }
  },
  watch: {
    '$route' (to, from) {
      this.currPath = to.path
    }
  },
  created () {
    if (config.help && config.help !== '') {
      this.menus.push({
        label: '系统帮助',
        icon: 'read',
        path: '/pages/help',
        prefix: 'help'
      })
    }
    this.currPath = this.$route.path
    const user = JSON.parse(sessionStorage.getItem('user'))
    this.user = user
    bs.data.product((res) => {
      if (res.code === 200) {
        sessionStorage.setItem('products', JSON.stringify(res.data))
      }
    })
    bs.data.orgProperties((res) => {
      if (res.code === 200) {
        sessionStorage.setItem('orgProperties', JSON.stringify(res.data))
      }
    })
    if (config.popInfo === true) {
      bs.serverConfig.popInfo((res) => {
        if (res.data.popUp === true) {
          this.popInfoVisible = true
          this.popUpStr = res.data.popUpStr
        }
      })
    }
    bs.serverConfig.config((res) => {
      if (res.code === 200) {
        config.serverConfig = res.data
      }
    })
  },
  methods: {
    openInfo () {
      window.open('https://grrb.yataiwuliu.com/static/shuoming.pdf', '_blank')
    },
    nav2login () {
      Cookies.remove(api.tokenKey)
      this.$router.push({ path: '/' })
    },
    changeArea () {
      if (this.selected.area !== '' && this.selected.area !== null) {
        bs.user.changeArea(this.selected.province + ',' + this.selected.city + ',' + this.selected.area, (res) => {
          if (res.code === 200) {
            this.$message({
              message: '行政区划保存成功',
              type: 'success'
            })
            sessionStorage.setItem('user', JSON.stringify(res.data))
            this.dialogVisible = false
          } else {
            this.$message.error('行政区划保存失败')
          }
        })
      } else {
        this.$message.error('请选择到区县')
      }
    },
    updateUserPhone (data) {
      this.user.phone = data
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.menu-clicked {
  background-color: #930c0a;
}

.footer {
  position: fixed;
  bottom: 0;
  height: 80px;
  width: 100vw;
  background-color: #232323;
  color: white;
  z-index: 1000;
}

.padding-10p {
  padding: 0 5%;
}

</style>
